import { FC } from "react"
import cx from "classnames"
import { HiOutlineDuplicate } from "react-icons/hi"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const DuplicateIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <HiOutlineDuplicate
      className={cx("w-5 h-5 active:scale-90", className)}
      {...rest}
    />
  )
}

export default DuplicateIcon
